export const BRAND_TYPE = {
    BRAND: 'BRAND',
    PARENT_BRAND: 'PARENT_BRAND',
    SUB_BRAND: 'SUB_BRAND'
}

export const BRAND_TYPE_LABEL = {
    [BRAND_TYPE.BRAND]: 'Brand',
    [BRAND_TYPE.PARENT_BRAND]: 'Parent Brand',
    [BRAND_TYPE.SUB_BRAND]: 'Sub-brand'
}

export const BRAND_CONSTANTS = {
    ENTER_BRAND_NAME: "Enter your brand name (50 characters)",
    DISPLAY_BRAND_NAME: "Brand name you would like to display on the storefront",
    ENTER_BRAND_TITLE: "Enter your brand title",
    ENTER_BRAND_DESCRIPTION: "Enter your brand description",
    TRUSTED_BRAND_SINCE: "Trusted brand on OFMP since",
    BRAND_TYPE_CONFIGURATION: "Brand type configuration",
    CUSTOMER_FACING_DESCRIPTION: "Enabling a brand as Customer-Facing allows you to consolidate multiple sub-brands under a single, unified identity. The Customer-Facing brand will be prominently displayed on your website, while any linked sub-brands remain hidden from public view.",
    MAKE_CUSTOMER_FACING: "Make customer-facing brand",
    MARK_PARENT_BRAND: "Mark as parent brand",
    BRAND_CANNOT_BE_ADDED: "This brand is already a sub brand",
    ADD_BRANDS: "Add brands",
    SELECT_BRANDS: "Select Brands",
    ENTER_BRAND_KEYWORDS: "Enter brand keyword(s)",
    BRAND_NAME: "Brand name",
    BRAND_TITLE: "Brand title",
    BRAND_DESCRIPTION: "Brand description",
    SEO_TITLE: "SEO title",
    SEO_DESCRIPTION: "SEO description",
    LINKED_BRANDS: "Linked Brands",
    SEO: "SEO",
    SEO_OPTIMIZATION_DESCRIPTION: "Use this section to optimize your brand's visibility in search engines. Fill in the title, description, and keywords to highlight key details and improve search rankings. Ensure the information is concise, relevant, and uses targeted keywords effectively.",
    ENTER_SEO_TITLE: "Enter your brand title",
    ENTER_SEO_DESCRIPTION: "Enter your brand description",
    ENTER_SEO_KEYWORDS: "Enter your brand keyword(s)",
    OPTIONAL: "Optional",
    KEYWORDS: "Keywords",
    INVALID_FILE_TYPE_ERROR: 'Invalid file type. Please upload an SVG image.',
    UPLOAD_LOGO: 'Upload brand logo',
    SUPPORTED_FORMAT: 'Supported format: SVG',   
    MAX_20_MB: 'Max. 20 MB',
    SELECT_VENDOR_TO_SHOW_BRANDS: "Please select a vendor to show its brands",
    NO_BRANDS_AVAILABLE: "No brands available.",
    NO_BRANDS_FOR_SELECTED_VENDOR: "No brands available for the selected vendor.",
    SELECT_VENDOR_BEFORE_CREATING_BRAND: "Please select a vendor before you try to create a brand.",
    TRACK_PRODUCTS_API: "This API helps you stay organized by tracking all the products used by your company via unique identifier, SKU number. However, if you prefer, you can still revert to the manual process by deselecting the same checkbox.",
    AUTOMATE_INVENTORY_API: "This API helps you automate your inventory management. However, if you prefer, you can still revert to the manual process by deselecting the same checkbox.",
    AUTOMATE_SALES_ORDER_API: "This API helps you automate sales order creation. However, if you prefer, you can still revert to the manual process by deselecting the same checkbox.",
    BACK: "Back",
    SAVE: "Save",
    ANY_CHANGE_SAVE_DISCLAIMER: " Any changes you made will not be saved.",
    PLEASE_SELECT_VENDOR: "Please select a vendor before you save your brand.",
    BRAND_UPDATED: 'Brand updated.',
    BRAND_CREATED: 'Brand created.',
    CREATE_BRAND: 'Create brand',
    CREATE_CUSTOMER_FACING_BRAND: 'Create customer-facing brand',
};



